<template lang="pug">
v-container(fluid fill-height)
  v-row(align='center' justify='center')
    v-col(cols='auto')
      v-card(max-width='500px' min-width='310px')
        v-card-title Entrar
        v-card-text
          v-form
            v-text-field(v-model='username' label='Username')
            v-text-field(v-model='password' type='password' label='Senha')
            v-btn(@click='login(username, password)' :loading='loading') Entrar
</template>

<script>
// import { AUTH_REQUEST } from '../store/actions/auth'

export default {
  data () {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    login (user, pass) {
      this.loading = true
      const axios = require('axios')

      const data = 'grant_type=&username=' + user + '&password=' + pass + '&scope=&client_id=&client_secret='

      axios.post(process.env.VUE_APP_BASE_API + '/auth/token',
        data,
        {
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
        .then((response) => {
          this.setUserToken(response.data.access_token)
          console.log('done!')
          this.loading = false
          this.$router.push('/')
        })
        .catch((response) => {
          this.setUserToken(null)
          console.log('Usuário ou senha inválidos')
          this.loading = false
        })
    },
    setUserToken (token) {
      console.log('setting user token')
      localStorage.setItem('user-token', token)
    }
  }
}
</script>
